




































import { Component, Prop, Vue } from 'vue-property-decorator'
// import { State, Mutation, namespace } from 'vuex-class';
import PageLayout from '@/components/page/PageLayout.vue'
import UserApi from '@/api/user'

@Component({
	name: 'UserCenter',
	components: {
		PageLayout,
	},
})
export default class UserCenter extends Vue {
	private data: object = {}

	private activated() {
		UserApi.getUserInfo().then((res: any) => {
			this.data = res.data
		})
	}
}
